import { graphql, HttpResponse } from 'msw'
import { type InvestmentAssetAllocationRecommendationOutput, InvestmentRiskToleranceCategory } from '../../../models'

export const investmentRiskToleranceRecommendationMock: InvestmentAssetAllocationRecommendationOutput = {
  currentRiskTolerance: InvestmentRiskToleranceCategory.BALANCED_1,
  currentAssetAllocationBreakdown: {
    equities: 61,
    fixedIncome: 34,
    cashEquivalent: 5,
  },
  recommendedRiskTolerance: InvestmentRiskToleranceCategory.BALANCED_4,
  allowedRiskTolerances: [
    InvestmentRiskToleranceCategory.BALANCED_1,
    InvestmentRiskToleranceCategory.BALANCED_2,
    InvestmentRiskToleranceCategory.BALANCED_3,
    InvestmentRiskToleranceCategory.BALANCED_4,
    InvestmentRiskToleranceCategory.BALANCED_5,
  ],
  riskTolerances: [
    {
      category: InvestmentRiskToleranceCategory.CONSERVATIVE_1,
      index: 0,
      allocation: {
        equities: 31,
        fixedIncome: 59,
        cashEquivalent: 10,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.CONSERVATIVE_2,
      index: 1,
      allocation: {
        equities: 35,
        fixedIncome: 55,
        cashEquivalent: 10,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.CONSERVATIVE_3,
      index: 2,
      allocation: {
        equities: 39,
        fixedIncome: 52,
        cashEquivalent: 9,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.CONSERVATIVE_4,
      index: 3,
      allocation: {
        equities: 43,
        fixedIncome: 48,
        cashEquivalent: 9,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.CONSERVATIVE_5,
      index: 4,
      allocation: {
        equities: 47,
        fixedIncome: 45,
        cashEquivalent: 8,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.MODERATE_1,
      index: 5,
      allocation: {
        equities: 49,
        fixedIncome: 44,
        cashEquivalent: 7,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.MODERATE_2,
      index: 6,
      allocation: {
        equities: 51,
        fixedIncome: 42,
        cashEquivalent: 7,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.MODERATE_3,
      index: 7,
      allocation: {
        equities: 53,
        fixedIncome: 40,
        cashEquivalent: 7,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.MODERATE_4,
      index: 8,
      allocation: {
        equities: 55,
        fixedIncome: 39,
        cashEquivalent: 6,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.MODERATE_5,
      index: 9,
      allocation: {
        equities: 57,
        fixedIncome: 37,
        cashEquivalent: 6,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.BALANCED_1,
      index: 10,
      allocation: {
        equities: 59,
        fixedIncome: 36,
        cashEquivalent: 5,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.BALANCED_2,
      index: 11,
      allocation: {
        equities: 61,
        fixedIncome: 34,
        cashEquivalent: 5,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.BALANCED_3,
      index: 12,
      allocation: {
        equities: 63,
        fixedIncome: 32,
        cashEquivalent: 5,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.BALANCED_4,
      index: 13,
      allocation: {
        equities: 65,
        fixedIncome: 31,
        cashEquivalent: 4,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.BALANCED_5,
      index: 14,
      allocation: {
        equities: 67,
        fixedIncome: 29,
        cashEquivalent: 4,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.GROWTH_1,
      index: 15,
      allocation: {
        equities: 69,
        fixedIncome: 28,
        cashEquivalent: 3,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.GROWTH_2,
      index: 16,
      allocation: {
        equities: 71,
        fixedIncome: 26,
        cashEquivalent: 3,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.GROWTH_3,
      index: 17,
      allocation: {
        equities: 73,
        fixedIncome: 24,
        cashEquivalent: 3,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.GROWTH_4,
      index: 18,
      allocation: {
        equities: 75,
        fixedIncome: 23,
        cashEquivalent: 2,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.GROWTH_5,
      index: 19,
      allocation: {
        equities: 77,
        fixedIncome: 21,
        cashEquivalent: 2,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.AGGRESSIVE_1,
      index: 20,
      allocation: {
        equities: 79,
        fixedIncome: 20,
        cashEquivalent: 1,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.AGGRESSIVE_2,
      index: 21,
      allocation: {
        equities: 83,
        fixedIncome: 16,
        cashEquivalent: 1,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.AGGRESSIVE_3,
      index: 22,
      allocation: {
        equities: 87,
        fixedIncome: 12,
        cashEquivalent: 1,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.AGGRESSIVE_4,
      index: 23,
      allocation: {
        equities: 91,
        fixedIncome: 8,
        cashEquivalent: 1,
      },
    },
    {
      category: InvestmentRiskToleranceCategory.AGGRESSIVE_5,
      index: 24,
      allocation: {
        equities: 95,
        fixedIncome: 4,
        cashEquivalent: 1,
      },
    },
  ],
}

export const mockGetInvestmentRiskToleranceRecommendationHandler = graphql.query(
  'investmentRiskToleranceRecommendation',
  () => {
    return HttpResponse.json({
      data: { investmentRiskToleranceRecommendation: investmentRiskToleranceRecommendationMock },
    })
  },
)

export const mockInvestmentRiskTolerance = [mockGetInvestmentRiskToleranceRecommendationHandler]
